/**
 * Provider 核心元数据（无 UI 依赖）。
 * 主站 lib/providers.ts 在此基础上合并 React 图标后再导出给 UI 使用；
 * 包内模型注册表只依赖这里的纯数据版本。
 */
export type TersaProvider = {
  id: string;
  name: string;
};

export type PriceBracket = 'lowest' | 'low' | 'high' | 'highest';

export const providers = {
  openai: {
    id: 'openai',
    name: 'OpenAI',
  },
  anthropic: {
    id: 'anthropic',
    name: 'Anthropic',
  },
  google: {
    id: 'google',
    name: 'Google',
  },
  xai: {
    id: 'xai',
    name: 'xAI',
  },
  vercel: {
    id: 'vercel',
    name: 'Vercel',
  },
  luma: {
    id: 'luma',
    name: 'Luma',
  },
  minimax: {
    id: 'minimax',
    name: 'Minimax',
  },
  'black-forest-labs': {
    id: 'black-forest-labs',
    name: 'Black Forest Labs',
  },
  deepseek: {
    id: 'deepseek',
    name: 'DeepSeek',
  },
  runway: {
    id: 'runway',
    name: 'Runway',
  },
  jimeng: {
    id: 'jimeng',
    name: 'JiMeng',
  },
  alibaba: {
    id: 'alibaba',
    name: 'Alibaba',
  },
  fal: {
    id: 'fal',
    name: 'Fal',
  },
  kling: {
    id: 'kling',
    name: 'Kling',
  },
  replicate: {
    id: 'replicate',
    name: 'Replicate',
  },
  midjourney: {
    id: 'midjourney',
    name: 'Midjourney',
  },
  bytedance: {
    id: 'bytedance',
    name: 'Bytedance',
  },
  recraft: {
    id: 'recraft',
    name: 'Recraft',
  },
  stable: {
    id: 'stable',
    name: 'Stable',
  },
  topaz: {
    id: 'topaz',
    name: 'Topaz',
  },
  elevenlabs: {
    id: 'elevenlabs',
    name: 'ElevenLabs',
  },
  vidu: {
    id: 'vidu',
    name: 'Vidu',
  },
  suno: {
    id: 'suno',
    name: 'Suno',
  },
  mureka: {
    id: 'mureka',
    name: 'Mureka',
  },
  zhipu: {
    id: 'zhipu',
    name: 'Zhipu',
  },
  moonshot: {
    id: 'moonshot',
    name: 'Moonshot',
  },
  xiaomi: {
    id: 'xiaomi',
    name: 'Xiaomi',
  },
  flowmuse: {
    id: 'flowmuse',
    name: 'FlowMuse',
  },
  hunyuan: {
    id: 'hunyuan',
    name: 'Hunyuan',
  },
  hyper3d: {
    id: 'hyper3d',
    name: 'Hyper3D',
  },
  tripo3d: {
    id: 'tripo3d',
    name: 'Tripo3D',
  },
  pixverse: {
    id: 'pixverse',
    name: 'PixVerse',
  },
  ideogram: {
    id: 'ideogram',
    name: 'Ideogram',
  },
  krea: {
    id: 'krea',
    name: 'Krea',
  },
  microsoft: {
    id: 'microsoft',
    name: 'Microsoft',
  },
  nvidia: {
    id: 'nvidia',
    name: 'NVIDIA',
  },
  skywork: {
    id: 'skywork',
    name: 'Skywork',
  },
  reve: {
    id: 'reve',
    name: 'Reve',
  },
};

export type TersaModel = {
  /**
   * 图标由主站 lib/providers.ts 收窄为具体 React 组件类型；
   * 包内用与组件签名双向兼容的宽类型，避免依赖 React。
   */
  icon?: (props: any) => any;
  /**
   * 模型唯一 ID（由聚合表注入）。展示名缺省时作为兜底。
   */
  id?: string;
  /**
   * @deprecated 展示名已迁移到数据库（model_access.labels）。代码内不再维护，
   * 缺省时按「数据库 labels → 模型 id」兜底（见 use-model-label）。保留为可选仅为兼容。
   */
  label?: string;
  /**
   * @deprecated 同 label，展示名已迁移到数据库。保留为可选仅为兼容。
   */
  labelI18n?: Record<string, string>;
  chef: TersaProvider;
  providers: TersaProvider[];
  legacy?: boolean;
  priceIndicator?: PriceBracket;
  /** 可选：用于 UI 显示的人类可读价格，如 "$2.5/$10 per 1M" */
  price?: string;
  disabled?: boolean;
  /** 默认模型标记，支持优先级：true = 1，数字越大越优先（见 getDefaultModelId）。 */
  default?: boolean | number;
  /** Optional short remark to display as a small second line in selectors */
  note?: string;
  /** 可选：note 的多语言版本，规则同 labelI18n */
  noteI18n?: Record<string, string>;
};
